export declare const ToDialog: any;
export default ToDialog;
export * from './src/dialog';
